import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import { aggregateTransactionData } from '@pages/shared/chart.config';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var TransactionService = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionService, _super);
    function TransactionService(http, _appState) {
        var _this = _super.call(this, http, MapperService.transactionMap) || this;
        _this._appState = _appState;
        _this._endpoint = _this._appState.authConfig.odataBaseUrl + "/QueueProcessingRecords/UiPathODataSvc.RetrieveQueuesProcessingStatus";
        return _this;
    }
    TransactionService.prototype.getTransactionStats = function (daysNo, queueDefId) {
        var _this = this;
        var endpoint = "UiPathODataSvc.RetrieveLastDaysProcessingRecords(daysNo=" + daysNo + ",queueDefinitionId=" + queueDefId + ")";
        return this._http.get(this._appState.authConfig.odataBaseUrl + "/QueueProcessingRecords/" + endpoint)
            .pipe(map(function (res) {
            var mapped = _this._mapData(res, MapperService.transactionStatsMap);
            return aggregateTransactionData(mapped.data);
        }));
    };
    return TransactionService;
}(ODataService));
export { TransactionService };
